import { UnsubscribePage } from '@online-webinar/account';
import { RouterType } from '@online-webinar/router';

export const updateRoute = (router: RouterType) => {
    router.routesById['/unsubscribe/$token'].update({
        staticData: { title: { page: 'Title.Unsubscribe' } },
        component: UnsubscribePage
    });
};
